import axiosClient from "./axiosClient";
import https from "https";

import ConstData from "../ConstData";

let options = {};

if (ConstData.IS_LOCAL_VERSION) {
    options = {
        httpsAgent: new https.Agent({
            rejectUnauthorized: false, // 허가되지 않은 인증을 reject하지 않겠다!
        })
    }
}

export const create_web = ({ creatorSEQ, chatRoomName, userArr }) => {
    const userSEQList = userArr.filter(user => user.userSeq !== creatorSEQ).map(user => user.userSeq);
    console.log("api create web chatRoom:) creatorSEQ[", creatorSEQ, "], chatRoomName[", chatRoomName, "], ", userSEQList);

    return axiosClient.post(`/chatting?kind=create&mode=web`, {
        chatRoomName, creatorSEQ, userSEQList
    }, options);
}

export const create = ({ creatorSEQ, chatRoomName, userArr, isWithTalk, isWithEntry }) => {
    if (userArr !== undefined && userArr !== null && userArr.length > 1) {
        const userSEQList = userArr.filter(user => user.userSeq !== creatorSEQ).map(user => user.userSeq);
        console.log("api create chatRoom with list:) creatorSEQ[", creatorSEQ, "], chatRoomName[", chatRoomName, "], userSEQList => ", userSEQList);
        console.log("api create chatRoom with list:) isWithTalk[", isWithTalk, "], isWithEntry[", isWithEntry, "]");

        return axiosClient.post(`/chatting?kind=create&mode=hiclass`, {
            chatRoomName, creatorSEQ, userSEQList, isWithTalk, isWithEntry
        }, options);
    } else {
        console.log("api create chatRoom with me:) creatorSEQ[", creatorSEQ, "], chatRoomName[", chatRoomName, "], isWithEntry[", isWithEntry, "]");

        return axiosClient.post(`/chatting?kind=create&mode=hiclass`, {
            chatRoomName, creatorSEQ, isWithEntry
        }, options);
    }
}

export const update_name = ({ chatRoomSeq, userSeq, chatRoomName }) => {
    console.log("api update name:) chatRoomSeq[", chatRoomSeq, "], userSeq[", userSeq, "], chatRoomName[", chatRoomName, "]");

    return axiosClient.put(`/chatting/${chatRoomSeq}/${userSeq}?kind=name`, {
        chatRoomName
    }, options);
}

export const update_type = ({ chatRoomSeq, userSeq, chatRoomType }) => {
    console.log("api update type:) chatRoomSeq[", chatRoomSeq, "], userSeq[", userSeq, "], chatRoomType[", chatRoomType, "]");

    return axiosClient.put(`/chatting/${chatRoomSeq}/${userSeq}?kind=type`, {
        chatRoomType
    }, options);
}

export const join = ({ chatRoomSeq, userSeq }) => {
    console.log("api chatRoom join:) chatRoomSeq[", chatRoomSeq, "], userSeq[", userSeq, "]");

    return axiosClient.post(`/chatting/${chatRoomSeq}/${userSeq}`, {}, options);
}

export const finish = ({ chatRoomSeq, userSeq }) => {
    console.log("api chatRoom finish:) chatRoomSeq[", chatRoomSeq, "], userSeq[", userSeq, "]");

    return axiosClient.delete(`/chatting/${chatRoomSeq}/${userSeq}?kind=finish`, options);
}

export const exit = ({ chatRoomSeq, userSeq }) => {
    console.log("api chatRoom exit:) chatRoomSeq[", chatRoomSeq, "], userSeq[", userSeq, "]");

    return axiosClient.delete(`/chatting/${chatRoomSeq}/${userSeq}?kind=exit`, options);
}

export const remove_chat = ({ chatRoomSeq, userSeq }) => {
    console.log("api chatRoom remove:) chatRoomSeq[", chatRoomSeq, "], userSeq[", userSeq, "]");

    return axiosClient.delete(`/chatting/${chatRoomSeq}/${userSeq}?kind=remove`, options);
}

export const get_inviteable_list = ({ chatRoomSeq, userSeq }) => {
    console.log("api get inviteable list:) chatRoomSeq[", chatRoomSeq, "], userSeq[", userSeq, "]");

    return axiosClient.get(`/chatting/${chatRoomSeq}/${userSeq}`, options);
}

export const invite_chat_member = ({ chatRoomSeq, userSeq, userSEQList }) => {
    console.log("api invite chat member:) chatRoomSeq[", chatRoomSeq, "], userSeq[", userSeq, "], userSEQList => ", userSEQList);

    return axiosClient.post(`/chatting/${chatRoomSeq}?kind=invite-member`, {
        userSEQ: userSeq,
        userSEQList: userSEQList
    }, options);
}

export const remove_chat_member = ({ chatRoomSeq, userSeq, removeUserSeq }) => {
    console.log("api remove chatRoom member:) chatRoomSeq[", chatRoomSeq, "], userSeq[", userSeq, "], removeUserSeq[", removeUserSeq, "]");

    return axiosClient.delete(`/chatting/${chatRoomSeq}/${userSeq}/${removeUserSeq}?kind=remove-member`, options);
}